import React, { useState } from 'react';
const CustomDropdown = ({ dropdownLength, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (val) => {
    onChange(val);
    setIsOpen(false);
  };
  const getLabel = (val) => {
    if (!val) return 'Select';
    if (val === 1) return 'First';
    if (val === dropdownLength) return 'Last';
    return val;
  };
  //console.log("CustomDropdown Value", value)
  return (
    <div className="pm-custom-dropdown">
      <div className="selected-value" onClick={() => setIsOpen(!isOpen)}>
        {getLabel(value)}
      </div>
      {isOpen && (
        <ul className="pm-dropdown-list">
          {Array.from({ length: dropdownLength }).map((_, index) => {
        const label =
          index === 0
            ? 'Move to First'
            : index === dropdownLength - 1
            ? 'Last'
            : index + 1;
        return (
          <li key={index} onClick={() => handleSelect(index + 1)}>
            {label}
          </li>
        );
      })}
        </ul>
      )}
    </div>
  );
}

export default CustomDropdown
